// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__xvNnt","content":"LoadingAlert_content__2C2Wi"};